import Loadable from 'react-loadable';
import Loading from 'components/Loading';

const MangeRooms = Loadable({
  loader: () => import('./Containers/manage-rooms'),
  loading: Loading
});

export default [
  {
    path: '/rooms',
    component: MangeRooms,
    private: true,
    menu: {
      name: 'Locations',
      group: 'Admin',
      order: 5,
      subGroup: 'Other',
      icons: 'icon-location-ic'
    }
  }
];



// WEBPACK FOOTER //
// ./src/Rooms/routes.js